import useMutation from "src/hooks/useMutation";

function useWarehouseDetailDistributionCreate(id) {
  return useMutation({
    path: `/api/v1/warehouses/${id}/distribution/many`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouses/${id}/distribution`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseDetailDistributionCreate;
